import React, {Component} from 'react';
import Modal from '../../../features/shared/containers/Modal';
import TextInput from '../../shared/components/forms/TextInput';
import {connect} from 'react-redux';
import isEmpty from 'is-empty';
import {Link} from 'react-router-dom';
import * as apiUrls from "../apiUrls";
import {showNotification} from "../../../utils/toast"
import {closeModal} from "../../shared/actions";
import axios from 'axios';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {TrackEventName} from '../../shared/constants/SegmentEvents';

class AlertFrequencyModal extends Component{
  constructor(props) {
    super(props)
    this.state = {
      email: "",
      frequency: "",
      errors: {}
    }

    this.renderContent = this.renderContent.bind(this);
    this.renderEmailInput = this.renderEmailInput.bind(this);
    this.saveAlert = this.saveAlert.bind(this);
  }

  async validateProjectAlert() {
    let errors = {};
    const {email, frequency} = this.state;

    if (isEmpty(email)) {
      errors["email"] = "Email is a required field";
    }

    if (isEmpty(frequency)) {
      errors["frequency"] = "Frequency is a required field";
    }

    if (!isEmpty(errors)) {
      this.setState({errors: errors});
      return false;
    } else {
      this.setState({errors: {}});
      return true;
    }
  }

  async saveAlert(event) {
    event.preventDefault();
    const filters = {
      keyword: this.props.keyword ? this.props.keyword.toUpperCase() : '',
      regions: this.props.regions,
      min_amount: this.props.min_amount,
      max_amount: this.props.max_amount
    };

    const project_alert = {
      filters: filters,
      frequency: this.state.frequency
    };

    if (this.validateProjectAlert()) {
      const payload = {
        user: {
          email: this.props.user.email || this.state.email,
          subscriber_type: isEmpty(this.props.user.email) ? "guest" : "fca_user"
        },
        project_alert: project_alert
      };

      axios(
        apiUrls.projectAlertsPost(),
        {
          data: payload,
          method: "POST",
        }
      )
      .then(response => {
        if (response.status === 201) {
          showNotification("success", `Your project alert is activated. You will receive an email at ${payload.user.email} when new projects are posted`);

          segmentEventTracker.trackEvent(TrackEventName.PROJECT_FINDER_ALERT_CREATED, payload);

          this.props.closeModal();
        }
      })
      .catch(errors => {
        if (errors.request.status === 422) {
          showNotification("warning", "Alert already exists");
          return;
        }

        const errorMessage = errors.message;
        showNotification("error", errorMessage);
      })
    }
  }

  handleEmailChange(event) {
    this.setState({
      email: event.target.value
    });
  }

  renderEmailInput() {
    const {user} = this.props;
    const {errors} = this.state;

    if (isEmpty(user.email)) {
      return (
        <section className="cardSection">
          <TextInput
            label="Email"
            name="email"
            type="email"
            value={this.state.email}
            onChange={event => this.handleEmailChange(event)}
            placeholder="Email"
            required={true}
            error={errors.email}
            requiredSymbol={true}
          />
        </section>
      );
    }
  }

  renderTermsAndConditionsLink() {
    return (
      <Link to={{pathname: "https://www.firstcircle.ph/website-terms-of-use"}}
        target="_blank"
        data-testid="terms-and-conditions"
        className=""
      >
        Terms and Conditions
      </Link>
    )
  }

  renderPrivacyPoliciesLink() {
    return (
      <Link to={{pathname: "https://www.firstcircle.ph/privacy-policy"}}
        target="_blank"
        data-testid="privacy-policy"
        className=""
      >
        Privacy Policy
      </Link>
    );
  }

  renderContent() {
    return (
      <div className="ds-card">
        <form onSubmit={this.saveAlert}>
          {this.renderEmailInput()}
          <section className="cardSection">
            <div className="text">
              <p className="copy"> How often do you want to be notified? </p>
            </div>
            <div className="ds-formGroup _padding--small">
              <div className="ds-radio">
                <input
                  type="radio"
                  name="frequency"
                  id="daily"
                  value="daily"
                  required="true"
                  onClick={(event) => this.setState({frequency: event.target.value})}
                />
                <label className="ds-btn" for="daily">Daily</label>
              </div>
              <div className="ds-radio">
                <input
                  type="radio"
                  name="frequency"
                  id="weekly"
                  value="weekly"
                  required="true"
                  onClick={(event) => this.setState({frequency: event.target.value})}
                />
                <label className="ds-btn" for="weekly">Weekly</label>
              </div>
            </div>
          </section>
          <section className="cardSection">
            <p className='byline _alignCenter'>
              By creating this alert, you agree to First Circle's {this.renderTermsAndConditionsLink()} and {this.renderPrivacyPoliciesLink()}.
            </p>
            <p className='byline _alignCenter'>
              You can unsubscribe from these alerts any time.
            </p>
          </section>
          <section className="cardSection _navigation">
            <div class="_right">
              <button className="ds-btn" type="submit" id="create-alert-btn">Create Alert</button>
            </div>
          </section>
        </form>
      </div>
    );
  }

  render() {
    return (
      <Modal
        name="projectAlertsModal"
        open={this.props.showModal}
        title="Create Project Alert"
        modalClassName='--full'
        gridClassName='--narrow'
        cardClassName='_tight'
        onCloseModal={this.props.onCloseModal}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    closeModal: () => dispatch(closeModal('projectAlertsModal')),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertFrequencyModal);



// WEBPACK FOOTER //
// ./src/features/projectFinder/components/AlertFrequencyModal.js